module.exports = __webpack_public_path__ + "static/media/blackLogo.be1a911a.png";